import { jsx as _jsx } from "react/jsx-runtime";
import Image from "next/image";
import { memo } from "react";
export const AnonymousSignUpModalHeader = /*#__PURE__*/ memo((param)=>{
    let { imageSrc, alt } = param;
    return /*#__PURE__*/ _jsx(Image, {
        priority: true,
        width: 496,
        height: 167,
        className: "rounded-t-md",
        alt: alt,
        src: imageSrc
    });
});
AnonymousSignUpModalHeader.displayName = "SharedLinkAnonymousSignInHeader";
